import tippy from 'tippy.js';

window.autosizeTextarea = function autosizeTextarea() {
  if (document.querySelector('textarea[data-autosize]')) {
    const autosizeTextareaElements = document.querySelectorAll(
      'textarea[data-autosize]'
    );
    autosizeTextareaElements.forEach((textarea) => {
      const startHeight = textarea.offsetHeight;
      textarea.addEventListener('input', autosize);
      function autosize() {
        const el = this;
        const newHeight = el.scrollHeight;
        if (newHeight > startHeight) {
          el.style.minHeight = `${el.scrollHeight}px`;
        } else {
          el.style.minHeight = startHeight;
        }
      }
    });
  }
};
autosizeTextarea();

window.initTooltipInfo = function initTooltipInfo() {
  const items = document.querySelectorAll('[data-ami-tooltip]:not(.is-init)');

  items.forEach((item) => {
    item.classList.add('is-init');

    tippy(item, {
      content: item.dataset.amiTooltip,
      placement: 'top-end',
      animation: 'fade',
      arrow: true,
      theme: 'ami-tooltip',
      allowHTML: true,
      appendTo: document.body,
    });
  });
};

initTooltipInfo();
